import { useDroppable } from '@dnd-kit/core';
import IconAdd from '../../components/icons/IconAdd';
import { STATIC_BLOCK_TYPE_LIST, INTERACTIVE_BLOCK_TYPE_LIST } from '../../variables/exerciseBlockTypes';
import { CONTAINER_LAYOUT_TYPE_LIST } from '../../variables/containerLayoutTypes';

// New blocks always append at the end of the list (position = max+1) - the
// user repositions via each card's up/down buttons afterward. Keeps the
// position math simple (no shifting every later block's position on
// insert-in-the-middle) at the cost of one extra click for mid-list inserts.
//
// `onPickContainer` is optional - only the top-level BlockList.jsx passes
// it (a container can't hold another container, so ContainerCard.jsx reuses
// this same picker for its own scoped "add block" without that 3rd group).
//
// `dropRegionId` is also optional and top-level-only - it makes this
// component's own outer wrap double as the "eject to top-level, append at
// the end" drag-and-drop target (see dnd/dndId.js's TOP_LEVEL_END_ID
// comment for why an explicit, always-registered dropzone is needed here
// rather than relying on incidental collision fallbacks). `useDroppable`
// must be called unconditionally (rules of hooks) even when this component
// is used WITHOUT that prop (ContainerCard.jsx's own scoped picker) -
// `disabled` in that case excludes it from collision detection entirely,
// so a shared/inert id across every ContainerCard instance is harmless.
export default function BlockTypePicker({ isOpen, onToggle, onPick, onPickContainer, dropRegionId }) {
   const { setNodeRef, isOver } = useDroppable({ id: dropRegionId || 'block-type-picker-inert', disabled: !dropRegionId });
   return (
      <div ref={setNodeRef} className={'exercise-block-add-wrap' + (isOver ? ' exercise-block-dropzone-over' : '')}>
         <div className='exercise-block-add-trigger' onClick={onToggle}>
            <IconAdd />
            <span>Додати блок</span>
         </div>
         {isOpen ? (
            <div className='exercise-block-type-picker'>
               <div className='exercise-block-type-group-label'>Контент</div>
               <div className='exercise-block-type-row'>
                  {STATIC_BLOCK_TYPE_LIST.map(bt => (
                     <div key={bt.type} className='exercise-block-type-chip' style={{'--accent':bt.accent}} onClick={() => onPick(bt)}>
                        {bt.label}
                     </div>
                  ))}
               </div>
               <div className='exercise-block-type-group-label'>Інтерактивні вправи</div>
               <div className='exercise-block-type-row'>
                  {INTERACTIVE_BLOCK_TYPE_LIST.map(bt => (
                     <div key={bt.type} className='exercise-block-type-chip' style={{'--accent':bt.accent}} onClick={() => onPick(bt)}>
                        {bt.label}
                     </div>
                  ))}
               </div>
               {onPickContainer ? (
                  <>
                     <div className='exercise-block-type-group-label'>Контейнер (розміщення)</div>
                     <div className='exercise-block-type-row'>
                        {CONTAINER_LAYOUT_TYPE_LIST.map(lt => (
                           <div key={lt.key} className='exercise-block-type-chip' style={{'--accent':'#7ec2e8'}} onClick={() => onPickContainer(lt)}>
                              {lt.label}
                           </div>
                        ))}
                     </div>
                  </>
               ) : ''}
            </div>
         ) : ''}
      </div>
   );
}
